<template>
    <div class="modify-container">
        <el-form :model="boardForm" :rules="rules" ref="boardForm" label-width="140px"
            :validate-on-rule-change="true" class="modify-form">

            <!-- 隐藏字段 -->
            <el-form-item label="企业Id" v-show="false">
                <el-input v-model="boardForm.companyId"></el-input>
            </el-form-item>
            <el-form-item label="用戶Id" v-show="false">
                <el-input v-model="boardForm.userId"></el-input>
            </el-form-item>

            <!-- ① 营业执照 -->
            <el-card shadow="never" class="form-section">
                <div slot="header" class="section-header">
                    <span class="section-title"><i class="el-icon-document"></i> 营业执照</span>
                    <span class="section-tip">请上传加盖公章的营业执照，支持 png / jpg / pdf 格式（pdf 不支持自动识别）</span>
                </div>
                <div class="license-row">
                    <el-upload class="license-upload"
                        :http-request="(file) => upload_images({ ...file, action: 'businessLicense' })"
                        accept=".jpg,.png,.pdf" :show-file-list="false" action="#"
                        :before-upload="beforeFileUpload">
                        <div v-if="!boardForm.businessLicense" class="upload-box">
                            <i class="el-icon-upload2"></i>
                            <div class="upload-hint">点击上传营业执照</div>
                            <div class="upload-sub">将自动识别并填充表单内容</div>
                        </div>
                        <img v-else :src="boardForm.businessLicense" @error="handleImageError" class="license-img" />
                    </el-upload>
                </div>
            </el-card>

            <!-- ② 基本信息 -->
            <el-card shadow="never" class="form-section">
                <div slot="header" class="section-header">
                    <span class="section-title"><i class="el-icon-office-building"></i> 基本信息</span>
                </div>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="企业名称" prop="companyName" required>
                            <el-input v-model="boardForm.companyName" placeholder="请输入企业全称" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="统一社会信用代码">
                            <div class="readonly-val">{{ boardForm.socialCreditCode }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="公司类型" prop="companyType" required>
                            <el-select v-model.number="boardForm.companyType" clearable placeholder="请选择" style="width:100%">
                                <el-option v-for="item in allCompanyType" :key="item.value"
                                    :label="item.name" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="成立日期" prop="setUpTime" required>
                            <el-date-picker v-model="boardForm.setUpTime" type="date"
                                placeholder="选择日期" clearable style="width:100%"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="法人代表" prop="legalPerson" required>
                            <el-input v-model="boardForm.legalPerson" placeholder="请输入法人代表" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="经营期限" prop="operatingPeriod" required>
                            <el-input v-model="boardForm.operatingPeriod"
                                placeholder="例: xxxx年xx月xx日 至 xxxx年xx月xx日" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册资金" prop="registeredCapital" required>
                            <el-input v-model="boardForm.registeredCapital" placeholder="请输入注册资金" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册地址" prop="registeredAddress" required>
                            <el-input v-model="boardForm.registeredAddress" placeholder="请输入注册地址" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="经营范围" prop="businessNature" required>
                            <el-input ref="businessNatureInput" type="textarea" :autosize="{ minRows: 4 }"
                                v-model="boardForm.businessNature" placeholder="请输入经营范围"
                                clearable @input="adjustTextareaHeight"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>

            <!-- ③ 财务信息 -->
            <el-card shadow="never" class="form-section">
                <div slot="header" class="section-header">
                    <span class="section-title"><i class="el-icon-bank-card"></i> 财务信息</span>
                </div>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="开户行" prop="accountBankName" required>
                            <el-input v-model="boardForm.accountBankName" placeholder="请输入开户行" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="对公账户名称" prop="accountName" required>
                            <el-input v-model="boardForm.accountName" placeholder="请输入对公账户名称" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="对公账户" prop="accountCode" required>
                            <el-input v-model="boardForm.accountCode" placeholder="请输入对公账户" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>

            <!-- ④ 联系人信息 -->
            <el-card shadow="never" class="form-section">
                <div slot="header" class="section-header">
                    <span class="section-title"><i class="el-icon-user"></i> 联系人信息</span>
                </div>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="联系人姓名" prop="contactsName" required>
                            <el-input v-model="boardForm.contactsName" placeholder="请输入联系人姓名" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系人电话" prop="contactsPhone" required>
                            <el-input v-model="boardForm.contactsPhone" placeholder="请输入联系人电话" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系人邮箱" prop="contactsEmail" required>
                            <el-input v-model="boardForm.contactsEmail" placeholder="请输入联系人邮箱" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>

            <!-- ⑤ 身份证件 -->
            <el-card shadow="never" class="form-section">
                <div slot="header" class="section-header">
                    <span class="section-title"><i class="el-icon-postcard"></i> 身份证件</span>
                </div>
                <el-form-item label="经办人是否为法人" prop="isLegalPerson" required>
                    <el-radio-group v-model="boardForm.isLegalPerson">
                        <el-radio label="是"></el-radio>
                        <el-radio label="否"></el-radio>
                    </el-radio-group>
                </el-form-item>

                <div class="idcard-group">
                    <div class="idcard-label">法人身份证</div>
                    <div class="idcard-uploads">
                        <div class="idcard-slot">
                            <el-upload class="idcard-upload" action="#"
                                :http-request="(file) => upload_images({ ...file, action: 'legalPersonIdCardFront' })"
                                accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                                <div v-if="!boardForm.legalPersonIdCardFront" class="upload-box idcard-box">
                                    <i class="el-icon-upload2"></i>
                                    <div class="upload-hint">点击上传正面</div>
                                </div>
                                <img v-else :src="boardForm.legalPersonIdCardFront" @error="handleImageError" class="idcard-img" />
                            </el-upload>
                            <div class="idcard-caption">正面</div>
                        </div>
                        <div class="idcard-slot">
                            <el-upload class="idcard-upload" action="#"
                                :http-request="(file) => upload_images({ ...file, action: 'legalPersonIdCardBack' })"
                                accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                                <div v-if="!boardForm.legalPersonIdCardBack" class="upload-box idcard-box">
                                    <i class="el-icon-upload2"></i>
                                    <div class="upload-hint">点击上传背面</div>
                                </div>
                                <img v-else :src="boardForm.legalPersonIdCardBack" @error="handleImageError" class="idcard-img" />
                            </el-upload>
                            <div class="idcard-caption">背面</div>
                        </div>
                    </div>
                </div>

                <!-- 经办人身份证（非法人） -->
                <div v-if="boardForm.isLegalPerson === '否'" class="idcard-group" style="margin-top:24px;">
                    <div class="idcard-label">经办人身份证</div>
                    <div class="idcard-uploads">
                        <div class="idcard-slot">
                            <el-upload class="idcard-upload" action="#"
                                :http-request="(file) => upload_images({ ...file, action: 'agentIdCardFront' })"
                                accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                                <div v-if="!boardForm.agentIdCardFront" class="upload-box idcard-box">
                                    <i class="el-icon-upload2"></i>
                                    <div class="upload-hint">点击上传正面</div>
                                </div>
                                <img v-else :src="boardForm.agentIdCardFront" @error="handleImageError" class="idcard-img" />
                            </el-upload>
                            <div class="idcard-caption">正面</div>
                        </div>
                        <div class="idcard-slot">
                            <el-upload class="idcard-upload" action="#"
                                :http-request="(file) => upload_images({ ...file, action: 'agentIdCardBack' })"
                                accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                                <div v-if="!boardForm.agentIdCardBack" class="upload-box idcard-box">
                                    <i class="el-icon-upload2"></i>
                                    <div class="upload-hint">点击上传背面</div>
                                </div>
                                <img v-else :src="boardForm.agentIdCardBack" @error="handleImageError" class="idcard-img" />
                            </el-upload>
                            <div class="idcard-caption">背面</div>
                        </div>
                    </div>

                    <!-- 授权书 -->
                    <div class="auth-letter-row">
                        <div class="auth-letter-info">
                            <div class="auth-letter-title">
                                <span class="required-mark">*</span> 企业身份审核授权书
                            </div>
                            <div class="auth-letter-desc">请下载模板，填写完整后上传签章版本</div>
                            <el-button type="primary" size="small" icon="el-icon-download" plain
                                @click="downloadFile('AuthorizationLetter.docx')">下载模板</el-button>
                        </div>
                        <el-upload class="auth-upload" action="#"
                            :http-request="(file) => upload_file({ ...file, action: 'authorizationLetter' })"
                            accept=".docx,.doc" :show-file-list="false">
                            <div v-if="!boardForm.authorizationLetter" class="auth-box">
                                <i class="el-icon-upload2 auth-box-icon"></i>
                                <div class="auth-box-hint">点击上传授权书</div>
                                <div class="auth-box-sub">支持 .doc / .docx</div>
                            </div>
                            <div v-else class="auth-box auth-box-done">
                                <i class="el-icon-circle-check auth-box-icon"></i>
                                <div class="auth-box-hint">授权书已上传</div>
                                <div class="auth-box-sub">点击可重新上传</div>
                            </div>
                        </el-upload>
                    </div>
                </div>
            </el-card>

            <!-- ⑥ 网站截图 -->
            <el-card shadow="never" class="form-section">
                <div slot="header" class="section-header">
                    <span class="section-title"><i class="el-icon-picture-outline"></i> 网站截图</span>
                </div>
                <div class="screenshot-notice">
                    <i class="el-icon-warning-outline"></i>
                    审核人员将在
                    <a href="https://www.creditchina.gov.cn" target="_blank">信用中国</a>、
                    <a href="http://www.ccgp.gov.cn/" target="_blank">中国政府采购网</a>、
                    <a href="https://wenshu.court.gov.cn/" target="_blank">中国裁判文书网</a>、
                    <a href="https://zxgk.court.gov.cn/" target="_blank">中国执行信息公开网</a>
                    上查询企业信息，请将查询截图上传留存。
                </div>
                <div class="screenshots-grid">
                    <div v-for="ss in screenshotList" :key="ss.key" class="screenshot-slot">
                        <el-upload class="screenshot-upload" action="#"
                            :http-request="(file) => upload_images({ ...file, action: ss.key })"
                            accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                            <div v-if="!boardForm[ss.key]" class="upload-box screenshot-box">
                                <i class="el-icon-upload2"></i>
                                <div class="upload-hint">点击上传</div>
                            </div>
                            <img v-else :src="boardForm[ss.key]" @error="handleImageError" class="screenshot-img" />
                        </el-upload>
                        <div class="screenshot-caption">{{ ss.label }}</div>
                    </div>
                </div>
            </el-card>

            <!-- ⑦ 声明 & 提交 -->
            <el-card shadow="never" class="form-section">
                <div class="declaration-box">
                    <el-checkbox v-model="boardForm.declarationChecked" class="declaration-check"></el-checkbox>
                    <div class="declaration-text">
                        我单位财务和经营状况良好，近三年没有发生重大数据安全事故，没有因违法经营受到刑事处罚或者责令停产停业、吊销许可证或者执照、较大数额罚款等行政处罚，若在数据交易过程中发现我单位近三年内在经营活动中有重大违法记录，我单位将承担因此引起的一切后果，特此声明！
                    </div>
                </div>
                <div class="submit-row">
                    <el-button type="primary" icon="el-icon-s-promotion" @click="submitForm"
                        :disabled="!boardForm.declarationChecked" size="medium">提交审核</el-button>
                    <el-button icon="el-icon-refresh-left" @click="resetForm" size="medium">重置</el-button>
                </div>
            </el-card>

        </el-form>
    </div>
</template>

<script>
export default {
    name: 'boardForm',
    data() {
        return {
            boardForm: {
                id: "",
                typeName: "",
                title: "",
                published: true,
                content: "",
                companyId: "",
                userId: "",
                companyName: "",
                socialCreditCode: "",
                noSocialCreditCode: false,
                companyType: "",
                registeredCapital: "",

                legalPerson: "",
                setUpTime: "",
                operatingPeriod: "",

                accountBankName: "",
                accountName: "",
                accountCode: "",

                contactsName: "",
                contactsPhone: "",
                contactsEmail: "",

                registeredAddress: "",
                businessNature: "",
                isLegalPerson: "是",

                picture: "",
                avatar: "",
                companyLogo: "",

                legalPersonIdCardFront: "",
                legalPersonIdCardBack: "",
                agentIdCardFront: "",
                agentIdCardBack: "",
                declarationChecked: false,
                businessLicense: "",
                authorizationLetter: "",

                courtScreenshot: "",
                zhiXingScreenshot: "",
                creditChinaScreenshot: "",
                ccgpScreenshot: "",

            },

            screenshotList: [
                { key: 'creditChinaScreenshot', label: '信用中国' },
                { key: 'ccgpScreenshot', label: '中国政府采购网' },
                { key: 'courtScreenshot', label: '中国裁判文书网' },
                { key: 'zhiXingScreenshot', label: '中国执行信息公开网' },
            ],

            allCompanyType: [
                { value: "全民所有制企业", name: "全民所有制企业" },
                {
                    value: "有限责任公司",
                    name: "有限责任公司",
                },
                {
                    value: "股份有限公司",
                    name: "股份有限公司",
                },
                {
                    value: "集体所有制",
                    name: "集体所有制",
                },
                {
                    value: "合伙企业",
                    name: "合伙企业",
                },
                {
                    value: "其他有限责任公司分公司",
                    name: "其他有限责任公司分公司",
                },
                {
                    value: "其他",
                    name: "其他",
                },
            ],

            rules: {
                companyName: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' }
                ],
                socialCreditCode: [
                    {
                        validator: (rule, value, callback) => {
                            if (!this.boardForm.noSocialCreditCode && !value) {
                                callback(new Error('请输入统一社会信用代码'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                companyType: [
                    { required: true, message: '请选择公司类型', trigger: 'change' }
                ],
                registeredCapital: [
                    { required: true, message: '请输入注册资金', trigger: 'blur' }
                ],
                registeredAddress: [
                    { required: true, message: '请输入注册地址', trigger: 'blur' }
                ],
                legalPerson: [
                    { required: true, message: '请输入法人姓名', trigger: 'blur' }
                ],
                setUpTime: [
                    { required: true, message: '请选择成立日期', trigger: 'change' }
                ],
                operatingPeriod: [
                    { required: true, message: '请输入经营期限', trigger: 'blur' }
                ],
                businessNature: [
                    { required: true, message: '请输入经营范围', trigger: 'blur' }
                ],
                accountBankName: [
                    { required: true, message: '请输入开户行', trigger: 'blur' }
                ],
                accountName: [
                    { required: true, message: '请输入对公账户名称', trigger: 'blur' }
                ],
                accountCode: [
                    { required: true, message: '请输入对公账户', trigger: 'blur' }
                ],
                contactsName: [
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' }
                ],
                contactsPhone: [
                    { required: true, message: '请输入联系人电话', trigger: 'blur' }
                ],
                contactsEmail: [
                    { required: true, message: '请输入联系人邮箱', trigger: 'blur' },
                ],
                isLegalPerson: [
                    { required: true, message: '请选择经办人是否为法人', trigger: 'change' }
                ]
            }
        }
    },

    mounted() {
        this.initDetailInfo();
    },
    methods: {
        handleLicenseSuccess(response) {
            this.boardForm.businessLicense = response.data.object.imageUrl;
            // 这里可以添加自动识别营业执照内容的逻辑
            // 例如调用OCR接口识别后自动填充表单
        },
        beforeLicenseUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isPDF = file.type === 'application/pdf';
            const isLt5M = file.size / 1024 / 1024 < 5;

            if (!isJPG && !isPNG && !isPDF) {
                this.$message.error('上传文件只能是 JPG/PNG/PDF 格式!');
                return false;
            }
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 5MB!');
                return false;
            }
            return true;
        },

        getBusinessLicense() {
            this.axios.get('/web/images/get?type=businessLicense', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.boardForm.businessLicense = imageUrl;
            }).catch(error => {
                console.error('获取营业执照失败:', error);
                this.$message.error('获取营业执照失败');
            });
        },

        handlePictureCardPreview(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true;
        },

        getLegalPersonIdCardFront() {
            this.axios.get('/web/images/get?type=legalPersonIdCardFront', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.boardForm.legalPersonIdCardFront = imageUrl;
            }).catch(error => {
                console.error('获取法人身份证失败:', error);
                this.$message.error('获取法人身份证失败');
            });
        },


        getLegalPersonIdCardBack() {
            this.axios.get('/web/images/get?type=legalPersonIdCardBack', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.boardForm.legalPersonIdCardBack = imageUrl;
            }).catch(error => {
                console.error('获取法人身份证失败:', error);
                this.$message.error('获取法人身份证失败');
            });
        },
        getZhiXingScreenshot() {
            this.axios.get('/web/images/get?type=zhiXingScreenshot', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.boardForm.zhiXingScreenshot = imageUrl;
            }).catch(error => {
                console.error('获取中国执行信息公开网截图失败:', error);
                this.$message.error('获取中国执行信息公开网截图失败');
            });
        },
        getCourtScreenshot() {
            this.axios.get('/web/images/get?type=courtScreenshot', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.boardForm.courtScreenshot = imageUrl;
            }).catch(error => {
                console.error('获取中国政府采购网截图失败:', error);
                this.$message.error('获取中国政府采购网截图失败');
            });
        },
        getCcgpScreenshot() {
            this.axios.get('/web/images/get?type=ccgpScreenshot', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.boardForm.ccgpScreenshot = imageUrl;
            }).catch(error => {
                console.error('获取中国裁判文书网截图失败:', error);
                this.$message.error('获取中国裁判文书网截图失败');
            });
        },
        getCreditChinaScreenshot() {
            this.axios.get('/web/images/get?type=creditChinaScreenshot', {
                responseType: 'blob'
            }).then(response => {
                const imageUrl = URL.createObjectURL(response.data);
                this.boardForm.creditChinaScreenshot = imageUrl;
            }).catch(error => {
                console.error('获取信用中国截图失败:', error);
                this.$message.error('获取信用中国截图失败');
            });
        },


        async downloadFile(customName) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/template/download/' + customName,
                    responseType: 'blob'
                });

                // 优先使用传入的自定义文件名
                let fileName = customName;
                //这里把文件名替换成中文，上面用英文是避免网络传输乱码问题，这里换成中文文件名下载时就正常了
                if (customName.startsWith('AuthorizationLetter')) {
                    fileName = "企业身份审核授权书-模版.docx"
                }


                // 处理中文文件名编码问题
                const encodedFileName = encodeURIComponent(fileName);

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                link.setAttribute('download-filename', encodedFileName); // 兼容性处理
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },


        submitForm() {
            this.$refs.boardForm.validate(valid => {
                if (!valid) {
                    return false;
                }

                // 校验必传文件
                if (!this.boardForm.businessLicense) {
                    this.$message.error('请上传营业执照');
                    return false;
                }

                if (!this.boardForm.legalPersonIdCardFront || !this.boardForm.legalPersonIdCardBack) {
                    this.$message.error('请上传法人身份证正反面照片');
                    return false;
                }

                if (this.boardForm.isLegalPerson === '否' && !this.boardForm.authorizationLetter) {
                    this.$message.error('请上传企业身份审核授权书');
                    return false;
                }

                if (this.boardForm.isLegalPerson === '否' &&
                    (!this.boardForm.agentIdCardFront || !this.boardForm.agentIdCardBack)) {
                    this.$message.error('请上传经办人身份证正反面照片');
                    return false;
                }

                if (!this.boardForm.creditChinaScreenshot || !this.boardForm.ccgpScreenshot ||
                    !this.boardForm.courtScreenshot || !this.boardForm.zhiXingScreenshot) {
                    this.$message.error('请上传所有网站截图');
                    return false;
                }

                this.$loading({
                    lock: true,
                    text: '提交中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                // 处理setUpTime字段，转换为YYYY-MM-DD格式
                const formData = {
                    ...this.boardForm,
                    setUpTime: this.formatDate(this.boardForm.setUpTime)
                };

                this.postRequest('/web/companyDetail/add', formData)
                    .then(response => {
                        this.$loading().close();
                        if (response.status === 200) {
                            this.$message.success('认证信息提交成功，请等待审核');
                            this.$router.push('/home');
                        } else {
                            this.$message.error(response.msg || '提交失败');
                        }
                    })
                    .catch(error => {
                        this.$loading().close();
                        this.$message.error('网络错误，请稍后重试');
                        console.error('提交失败:', error);
                    });
            });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 1;

            if (!isJPG && !isPNG) {
                this.$message.error("上传Logo图片只能是 jpg/png 的格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传Logo图片大小不能超过 1MB!");
            }
            return (isJPG || isPNG) && isLt2M;
        },

        uploadFile(file) {
            let formData = new FormData();
            formData.append("avatar", file.file);
            //传入其他的参数
            this.postFileRequest("/web/file/uploadAvatar", formData)
                .then((response) => {
                    this.boardForm.companyLogo = response.data.object.imageUrl;
                })
                .catch((error) => {
                    this.$message.error("上传失败，请稍后重试...");
                });
        },

        async upload_images(options) {
            const formData = new FormData();
            formData.append('file', options.file);

            // 根据上传类型设置不同参数
            let type = '';
            if (options.action === 'legalPersonIdCardFront') {
                type = 'legalPersonIdCardFront';
            } else if (options.action === 'legalPersonIdCardBack') {
                type = 'legalPersonIdCardBack';
            } else if (options.action === 'agentIdCardFront') {
                type = 'agentIdCardFront';
            } else if (options.action === 'agentIdCardBack') {
                type = 'agentIdCardBack';
            } else if (options.action === 'businessLicense') {
                type = 'businessLicense';
            } else if (options.action === 'creditChinaScreenshot') {
                type = 'creditChinaScreenshot';
            } else if (options.action === 'ccgpScreenshot') {
                type = 'ccgpScreenshot';
            } else if (options.action === 'courtScreenshot') {
                type = 'courtScreenshot';
            } else if (options.action === 'zhiXingScreenshot') {
                type = 'zhiXingScreenshot';
            }
            console.log(type);
            formData.append('type', type);

            this.$axios.post('/web/images/upload', formData, {
                responseType: 'blob'
            }).then(response => {
                console.log(response);
                const fileUrl = URL.createObjectURL(response.data);
                switch (type) {
                    case 'legalPersonIdCardFront':
                        this.boardForm.legalPersonIdCardFront = fileUrl;
                        break;
                    case 'legalPersonIdCardBack':
                        this.boardForm.legalPersonIdCardBack = fileUrl;
                        break;
                    case 'agentIdCardFront':
                        this.boardForm.agentIdCardFront = fileUrl;
                        break;
                    case 'agentIdCardBack':
                        this.boardForm.agentIdCardBack = fileUrl;
                        break;
                    case 'businessLicense':
                        this.boardForm.businessLicense = fileUrl;
                        this.parseBusinessLicense();
                        break;
                    case 'authorizationLetter':
                        this.boardForm.authorizationLetter = fileUrl;
                        break;


                    case 'creditChinaScreenshot':
                        this.boardForm.creditChinaScreenshot = fileUrl;
                        break;
                    case 'ccgpScreenshot':
                        this.boardForm.ccgpScreenshot = fileUrl;
                        break;
                    case 'courtScreenshot':
                        this.boardForm.courtScreenshot = fileUrl;
                        break;
                    case 'zhiXingScreenshot':
                        this.boardForm.zhiXingScreenshot = fileUrl;
                        break;
                }
            }).catch(error => {
                console.error('获取照片失败:', error);
                this.$message.error('获取照片失败');
            });
        },


        // 智能解析营业执照
        async parseBusinessLicense() {

            const loadingInstance = this.$loading({
                lock: true,
                text: '正在解析营业执照...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            try {
                const response = await this.$axios.get('/web/businessLicense/getInfo');
                if (response.data) {
                    this.fillBusinessLicenseInfo(response.data);
                } else {
                    this.$message.warning('未能解析出营业执照信息');
                }
            } catch (error) {
                console.error('解析营业执照失败:', error);
                this.$message.error('解析营业执照失败');
            } finally {
                loadingInstance.close();
            }
        },

        // 填充营业执照信息到表单
        fillBusinessLicenseInfo(info) {
            this.boardForm.companyName = info.companyName || this.boardForm.companyName;
            this.boardForm.socialCreditCode = info.socialCreditCode || this.boardForm.socialCreditCode;
            this.boardForm.companyType = info.companyType || this.boardForm.companyType;
            this.boardForm.registeredCapital = info.registeredCapital || this.boardForm.registeredCapital;
            this.boardForm.registeredAddress = info.registeredAddress || this.boardForm.registeredAddress;
            this.boardForm.legalPerson = info.legalPerson || this.boardForm.legalPerson;
            this.boardForm.setUpTime = new Date(info.setUpTime);
            this.boardForm.operatingPeriod = info.operatingPeriod || this.boardForm.operatingPeriod;
            this.boardForm.businessNature = info.businessNature || this.boardForm.businessNature;

            this.$nextTick(() => {
                this.adjustTextareaHeight();
            });
            this.$message.success('营业执照信息已解析完成');
        },

        // 调整textarea高度
        adjustTextareaHeight() {
            if (this.$refs.businessNatureInput) {
                const textarea = this.$refs.businessNatureInput.$el.querySelector('textarea');
                if (textarea) {
                    textarea.style.height = 'auto';
                    const scrollHeight = textarea.scrollHeight;
                    textarea.style.height = `${scrollHeight}px`;
                }
            }
        },
        async upload_file(options) {
            const formData = new FormData();
            formData.append('file', options.file);


            this.$axios.post('/web/authorization/fileUpload', formData, {

                responseType: 'blob'

            }).then(response => {
                this.boardForm.authorizationLetter = URL.createObjectURL(response.data);
            }).catch(error => {
                console.error('上传企业身份审核授权书成败:', error);
                this.$message.error('上传企业身份审核授权书失败');
            });
            // 更新授权书状态




        },

        beforeFileUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isPDF = file.type === 'application/pdf';
            const isLt10M = file.size / 1024 / 1024 < 100;

            if (!isJPG && !isPNG && !isPDF) {
                this.$message.error('上传文件只能是 JPG/PNG/PDF 格式!');
                return false;
            }
            if (!isLt10M) {
                this.$message.error('上传文件大小不能超过 100MB!');
                return false;
            }
            return true;
        },

        initDetailInfo() {


            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useid:  " + user.id)


            this.getRequest(
                "/web/companyDetail/queryForModify?userId=" + user.id
            ).then((resp) => {
                console.log(resp.data);
                if (resp) {
                    this.boardForm = resp.data;
                    this.getBusinessLicense();
                    this.getLegalPersonIdCardFront();
                    this.getLegalPersonIdCardBack();
                    this.getCreditChinaScreenshot();
                    this.getCcgpScreenshot();
                    this.getZhiXingScreenshot();
                    this.getCourtScreenshot();
                }

            });


        },

        handleNoCreditCodeChange(val) {
            if (val) {
                this.boardForm.socialCreditCode = "无";
            } else {
                this.boardForm.socialCreditCode = "";
            }
        },
        resetForm() {
            this.$refs.boardForm.resetFields()
        },

        // 格式化日期为YYYY-MM-DD
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        // 处理图片加载失败
        handleImageError(event) {
            const img = event.target;
            console.error('图片加载失败:', img.src);

            // 移除错误处理，防止无限循环
            img.onerror = null;

            // 使用base64编码的默认图片，确保总是可用
            img.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IiNmNWY1ZjUiIHN0cm9rZT0iI2RjZGNkYyIvPjx0ZXh0IHg9IjUwIiB5PSI1MCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+SW1hZ2UgTm90IEZvdW5kPC90ZXh0Pjwvc3ZnPg==';

            // 或者使用更简单的占位图
            // img.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IiNlNWU1ZTUiLz48cGF0aCBkPSJNNjUgNTBMMzUgNzVWMjVMNjUgNTBaIiBmaWxsPSIjY2NjIi8+PHBhdGggZD0iTTY1IDUwTDk1IDc1VjI1TDY1IDUwWiIgZmlsbD0iI2FhYSIvPjwvc3ZnPg==';
        },
    }
}
</script>

<style scoped>
.auth-form-container {
    padding: 0px;
    margin: 0;
    width: 100%;
    max-width: none;
    /* 添加这行，移除最大宽度限制 */
    box-sizing: border-box;
    /* 确保padding和border包含在宽度内 */
}

.auth-form-card {
    margin-bottom: 15px;
    border-radius: 10px !important;
    width: 100%;
    /* 改为100% */
    margin: 0;
}

.item {
    float: left;
    /* 或者 right，取决于你想要哪个元素在左边或右边 */
    width: 50%;
    /* 或者具体的像素值，确保两个div加起来等于父容器的宽度 */
}

.container::after {
    content: "";
    clear: both;
    /* 清除浮动 */
    display: table;
    /* 为了确保清除有效 */
}

.w-e-text-container {
    background-color: white;
    height: 450px !important;
}

.editor {
    margin-top: 40px;
    /*position: relative;
        margin-top: 200px;*/
}

.form-item {
    width: 100%;
    /* max-width: 500px; */
    text-align: left;
}

.board-form {
    margin-top: 20px;
}

.card-body {
    display: flex;
    align-items: center;
    height: 100px;
    padding: 0;
}
</style>
<style scoped>
.card-content {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
    padding: 0 20px;
}

.card-num {
    font-size: 30px;
}

.card-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.bg1 {
    background: #2d8cf0;
}

.bg2 {
    background: #64d572;
}

.bg3 {
    background: #f25e43;
}

.bg4 {
    background: #e9a745;
}

.color1 {
    color: #2d8cf0;
}

.color2 {
    color: #64d572;
}

.color3 {
    color: #f25e43;
}

.color4 {
    color: #e9a745;
}

.chart {
    width: 100%;
    height: 400px;
}

.card-header {
    padding-left: 10px;
    margin-bottom: 20px;
}

.card-header-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
}

.card-header-desc {
    font-size: 14px;
    color: #999;
}

.timeline-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #000;
}

.timeline-time,
.timeline-desc {
    font-size: 12px;
    color: #787878;
}

.rank-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.rank-item-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f2f2f2;
    text-align: center;
    line-height: 40px;
    margin-right: 10px;
}

.rank-item-content {
    flex: 1;
}

.rank-item-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #343434;
    margin-bottom: 10px;
}

.rank-item-desc {
    font-size: 14px;
    color: #999;
}

.map-chart {
    width: 100%;
}

.paragraph-style {
    margin-bottom: 6px;
}

.div-style {
    margin-top: 20px;
}

.left-aligned-black-text {
    color: black;
    text-align: left;
    /* 通常text-align默认为left，但明确指定也无妨 */
}

.paragraph-style {
    margin-bottom: 6px;
}

.label-left {
    text-align: left !important;
    /* 使用!important确保覆盖默认样式 */
}

.upload-section {
    margin-bottom: 20px;
}

.upload-area {
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 10px;
}

.upload-placeholder {
    color: #8c939d;
    font-size: 14px;
}

.upload-icon {
    font-size: 28px;
    margin-bottom: 10px;
}

.file-preview {
    padding: 10px;
    background: #f5f7fa;
    border-radius: 4px;
    display: flex;
    align-items: center;
}

.file-preview i {
    margin-right: 10px;
    color: #67C23A;
}

.download-links {
    margin-bottom: 15px;
}

.download-link {
    color: #409EFF;
    cursor: pointer;
    margin-right: 15px;
    font-size: 14px;
}

.upload-header1 {
    margin-bottom: 15px;
    font-size: 14px;
    color: #606266;
}

.required-mark {
    color: #f56c6c;
    margin-right: 5px;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}


.idcard-uploads {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
}

.idcard-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.idcard-upload {
    width: 200px;
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.idcard-box {
    width: 200px;
    height: 130px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
}

.idcard-img {
    width: 200px;
    height: 130px;
    object-fit: cover;
    border-radius: 4px;
}

.idcard-caption {
    margin-top: 6px;
    font-size: 13px;
    color: #606266;
    text-align: center;
}

.idcard-label {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 10px;
}

.screenshots-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
}

.screenshot-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.screenshot-caption {
    margin-top: 6px;
    font-size: 13px;
    color: #606266;
    text-align: center;
}

.screenshot-img {
    width: 200px;
    height: 150px;
    object-fit: cover;
    border-radius: 4px;
}

.screenshot-box {
    width: 200px;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
}

.screenshots-container {
    display: flex;
    justify-content: flex-start;

    flex-wrap: wrap;
    gap: 20px;
    margin-left: 0;
}

.screenshot-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 200px;
    flex: 1 0 auto;
    margin-bottom: 20px;
}

.screenshot-upload {
    width: 200px;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
}

.screenshot-preview {
    width: 200px;
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.screenshot-label {
    margin-top: 10px;
    font-weight: bold;
    text-align: center;
    width: 100%;
}

/* 响应式调整 */
@media (max-width: 1200px) {
    .screenshot-item {
        flex: 0 0 calc(50% - 20px);
    }
}

@media (max-width: 768px) {
    .screenshots-container {
        justify-content: center;
    }

    .screenshot-item {
        flex: 0 0 100%;
        max-width: 250px;
    }
}

@media (max-width: 480px) {
    .screenshot-item {
        width: 100%;
        max-width: none;
    }

    .screenshot-upload,
    .screenshot-preview {
        width: 100%;
        max-width: 250px;
        height: 180px;
    }
}

/* 授权书 */
.auth-letter-row {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    margin-top: 20px;
    padding: 16px;
    background: #f9fafc;
    border: 1px solid #e8eaf0;
    border-radius: 6px;
}

.auth-letter-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 200px;
}

.auth-letter-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.auth-letter-desc {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
}

.auth-upload {
    flex-shrink: 0;
}

.auth-box {
    width: 180px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: 1px dashed #c0c4cc;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
}

.auth-box:hover {
    border-color: #409eff;
    background: #ecf5ff;
}

.auth-box-done {
    border-color: #67c23a;
    background: #f0f9eb;
}

.auth-box-done:hover {
    border-color: #85ce61;
    background: #e1f3d8;
}

.auth-box-icon {
    font-size: 24px;
    color: #909399;
}

.auth-box-done .auth-box-icon {
    color: #67c23a;
}

.auth-box-hint {
    font-size: 13px;
    color: #606266;
}

.auth-box-done .auth-box-hint {
    color: #67c23a;
    font-weight: 500;
}

.auth-box-sub {
    font-size: 11px;
    color: #c0c4cc;
}
</style>